<template>
    <div class="sc flex column">
        <div class="flex-item chart-title">{{ timeRangeText }}服务类别完成</div>
        <div class="flex grow center">
            <div class="sc-chart">
                <e-charts :options="options"
                    :init-options="initOptions"
                    ref="chart"
                    autoresize />
            </div>
        </div>
    </div>
</template>
<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import theme from '../components/theme'
import common from './common'
import loopPlayTooltip from '_u/echarts/loop-play-tooltip'

export default {
    name: 'ServiceStatus',

    mixins: [theme, common],

    components: {
        ECharts
    },

    props: {
        // 服务类别数据
        list: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            chart: null,
            loopPlayer: null,
            chartData: [],
            serviceType: this.$dict.NULL,
        }
    },

    watch: {
        list: {
            handler() {
                this.setData()
            },
            immediate: true,
        },

        orderDataSource: {
            handler() {
                this.setData()
            },
        },

        options(val) {
            if (this.loopPlayer) {
                this.loopPlayer.startLoop(val)
            }
        },
    },

    computed: {
        initOptions() {
            return {
                renderer: 'canvas'
            }
        },

        options() {
            var vm = this

            return {
                color: ['#55CD6F', '#FFE464', '#FF3739'],
                tooltip: {
                    trigger: 'axis',
                    triggerOn: 'mousemove',
                    axisPointer: { // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
                    },
                    formatter: function(params, ticket, callback) {
                        var list = ''

                        for (let index = 0; index < params.length; index++) {
                            const el = params[index],
                                count = vm.chartData[el.dataIndex].count[el.seriesIndex]

                            list += `<div class="flex">
                                <span class="flex-item osc-bar-name">${el.seriesName}：</span>
                                <span class="flex-item grow osc-bar-count">${count} </span>
                                <span class="flex-item osc-bar-value">${el.value}%</span>
                            </div>`
                        }

                        return `<div class="osc-bar-tooltip">
                            <div class="osc-bar-tooltip-title">${params[0].name}</div>
                            ${list}
                        </div>`
                    }
                },
                legend: {
                    data: ['按时完成', '超时完成', '未完成'],
                    itemWidth: this.dp2p(12),
                    itemHeight: this.dp2p(12),
                    textStyle: {
                        color: this.theme.osLabelColor,
                    },
                },
                grid: {
                    top: '20%',
                    left: '3%',
                    right: '6%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'value',
                    splitLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: this.theme.osLabelColor,
                        }
                    },
                    axisLabel: {
                        color: this.theme.osLabelColor,
                        formatter(value) {
                            return value + "%"
                        }
                    },
                    max: 100,
                },
                yAxis: {
                    type: 'category',
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: this.theme.osLabelColor,
                        }
                    },
                    axisLabel: {
                        color: this.theme.osLabelColor,
                    },
                    data: this.chartData.map(v => v.serviceName)
                },
                // series需要沿着Y轴（serviceName）排列的value，通过data转置得到
                series: [{
                    name: '按时完成',
                    type: 'bar',
                    stack: '总量',
                    barMaxWidth: 16,
                    data: this.chartData.map(v => v.data[0])
                }, {
                    name: '超时完成',
                    type: 'bar',
                    stack: '总量',
                    barMaxWidth: 16,
                    data: this.chartData.map(v => v.data[1])
                }, {
                    name: '未完成',
                    type: 'bar',
                    stack: '总量',
                    barMaxWidth: 16,
                    data: this.chartData.map(v => v.data[2])
                }, ]
            }
        },
    },

    mounted() {
        this.chart = this.$refs.chart
        this.loopPlayer = loopPlayTooltip(this.chart.chart, {
            seriesIndex: [0, 1, 2],
            reverse: true,
        })
    },

    methods: {
        setData() {
            this.$dict.get("service_type")
                .then(dict => {
                    this.serviceType = dict
                })
                .then(() => {
                    let result = []
                    let data = this.list

                    // 工单类型过滤
                    if (this.orderDataSource && this.orderDataSource != 'all') {
                        data = data.filter(v => v.orderDataSource == this.orderDataSource)
                    }

                    // delay: 0
                    // ing: 1
                    // ontime: 0
                    // serviceType: "XJ"
                    // total: 1
                    // 按服务类型分组
                    let serviceTypeGroup = data.groupBy('serviceType')
                    Object.keys(serviceTypeGroup).forEach(t => {
                        var list = serviceTypeGroup[t]

                        result.push(list.reduce((acc, v) => {
                            acc.ontime += v.ontime
                            acc.delay += v.delay
                            acc.ing += v.ing
                            acc.total += v.total

                            return acc
                        }, {
                            ontime: 0,
                            delay: 0,
                            ing: 0,
                            total: 0,
                            serviceType: t
                        }))
                    })

                    // 格式化
                    result = result.map(v => ({
                        serviceName: this.serviceType.val(v.serviceType),
                        data: [
                            v.total ? parseFloat(v.ontime / v.total * 100).toFixed(0) : 0,
                            v.total ? parseFloat(v.delay / v.total * 100).toFixed(0) : 0,
                            v.total ? parseFloat(v.ing / v.total * 100).toFixed(0) : 0,
                        ],
                        count: [
                            v.ontime,
                            v.delay,
                            v.ing
                        ],
                    }))

                    this.chartData = result
                })
        },
    }
}
</script>
<style lang="less"
    scoped>
@import '../components/theme.less';

.echarts {
    width: 100%;
    height: 100%;
}

.sc {
    height: 100%;

    &-chart {
        width: 400px;
        height: 240px;
    }
}
</style>